import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PDFLeadMagnet from '../components/PDFLeadMagnet.jsx';
import Navigation from '../components/Navigation.jsx';
function IndividualSessions() {
  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  const [isRootCause1Expanded, setIsRootCause1Expanded] = useState(false);
  const [isRootCause2Expanded, setIsRootCause2Expanded] = useState(false);
  return <div className="min-h-screen bg-gradient-to-b from-white to-cream-50">
      <Navigation variant="transparent-to-solid" scrolled={false} />
      
      {/* Hero Banner Section - Full Width */}
      <section className="relative w-full mt-[0x] mb-[0x] ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
        {/* Hero Image - Full Width */}
        <div className="relative w-full h-[480px] md:h-[560px] lg:h-[640px]">
          <img src="https://res.cloudinary.com/makerinc/image/fetch/c_limit,w_1200,f_auto,q_auto:best,fl_preserve_transparency,dpr_2/https%3A%2F%2Fmaker-devi-dev.s3-accelerate.amazonaws.com%2Fuploads%2Fuser_33tbl7B6e1bXN6KW4wjrevvqrth%2Fcmhd1gtfc0001vb0yeeofdn9z%2Fmessages%2Fasian-powerful-free-lady-rxunbv15g1.jpg" alt="Woman looking thoughtful and empowered" className="w-full h-full object-cover" style={{
          objectPosition: 'center 30%'
        }} />
          
          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70"></div>
          
          {/* Text Content Overlay */}
          <div className="absolute inset-0 flex items-end justify-center pb-12">
            <div className="max-w-4xl text-center px-8">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-white leading-tight mb-6" style={{
              textShadow: '0 2px 20px rgba(0, 0, 0, 0.3)'
            }}>Individual Sessions</h1>
              <p className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed mb-6 drop-shadow-lg" style={{
              lineHeight: '1.6'
            }}>{"I help you understand the roots of your people-pleasing patterns, heal trauma, and break cycles of generational pain, so you can reclaim your authentic voice."}</p>
              <p className="text-base md:text-lg lg:text-xl text-white leading-relaxed font-medium drop-shadow-lg">People-pleasing is not a character flaw - it is a nervous system trauma response.<br />And healing is possible.</p>
            </div>
          </div>

          {/* Scroll Arrow */}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-float">
            <div className="bg-white bg-opacity-20 backdrop-blur-sm rounded-full p-3 hover:scale-110 transition-transform duration-300 cursor-pointer">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="relative py-16">
            <div className="absolute inset-0 bg-gradient-to-r from-sage-50 to-warm-50 rounded-3xl"></div>
            <div className="relative px-8 md:px-12 text-center">
              <svg className="w-12 h-12 text-warm-300 mx-auto mb-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
              </svg>
              <p className="text-2xl md:text-3xl font-serif font-light text-sage-800 leading-relaxed mb-6">{"Childhood trauma, including emotional neglect, happens in the context of relationships and so does healing. Safe, compassionate, respectful relationships where there is a quiet permission for you to move at your own pace. Healing feels like slowly allowing our bodies to take up more space in our relational world ... one breath, one moment, one brave step at a time.... \"my space, my pace\""}</p>
              <p className="text-sage-600 font-medium">{"- Yasi Philipos, Licensed MFT"}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="px-4 sm:px-6 lg:px-8 pb-16 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            
            {/* What Is People-Pleasing */}
            <h2 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6">What Is People-Pleasing?</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">{"People-pleasing isn't about being kind or generous, it's about abandoning yourself to keep others comfortable. It's saying yes when everything in you wants to say no. It's staying silent when you want to speak up. It's making yourself small so no one feels threatened. It's carrying the weight of everyone else's emotions while ignoring your own."}</p>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              You might recognize it in the way you:
            </p>
            <ul className="space-y-2 text-gray-600 mb-6 ml-6">
              <li className="flex items-start">
                <span className="text-sage-300 mr-3 mt-1">•</span>
                <span>Feel responsible for everyone else's happiness</span>
              </li>
              <li className="flex items-start">
                <span className="text-sage-300 mr-3 mt-1">•</span>
                <span>Struggle to say no without guilt or over-explaining</span>
              </li>
              <li className="flex items-start">
                <span className="text-sage-300 mr-3 mt-1">•</span>
                <span>Avoid conflict at all costs, even when it hurts you</span>
              </li>
              <li className="flex items-start">
                <span className="text-sage-300 mr-3 mt-1">•</span>
                <span>Lose yourself in relationships, adapting to what others need</span>
              </li>
              <li className="flex items-start">
                <span className="text-sage-300 mr-3 mt-1">•</span>
                <span>Feel chronically anxious, exhausted, or resentful</span>
              </li>
            </ul>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              <strong className="text-sage-800">People-pleasing is not a character flaw - it is a nervous system trauma response.</strong> It's what's known as a fawn response, an automatic survival strategy your body learned when fighting, fleeing, or freezing didn't feel like options.
            </p>

            {/* Healing Box About Not Blaming Parents */}
            <div className="my-12 bg-gradient-to-br from-warm-50 to-sage-50 rounded-3xl p-8 md:p-12 border border-warm-100">
              <p className="text-lg text-gray-600 leading-relaxed">{"Healing chronic pleasing patterns is never about blaming your parents or caregivers. Most often, our parents did the best they could with the tools and awareness they had at the time. They were likely dealing with their own unhealed trauma, their own people-pleasing patterns. These patterns are passed down through generations, not because anyone wanted to hurt you, but because hurt people often unintentionally pass on what was never healed in them."}</p>
            </div>

            {/* ROOT CAUSES SECTION */}
            <h2 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mt-16 mb-8">Root Causes of People-Pleasing</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              People-pleasing doesn't develop in a vacuum. It's a brilliant adaptation to two powerful forces: <strong className="text-sage-800">trauma</strong> and <strong className="text-sage-800">social conditioning</strong>. Understanding these roots helps you heal with compassion instead of shame.
            </p>

            {/* Root Cause 1: Trauma */}
            <div className="my-12 bg-gradient-to-br from-sage-50 to-cream-50 rounded-3xl p-8 md:p-12 border border-sage-100">
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-800 flex-1">{"Root Cause 1: Trauma : \"Big T\" and Complex Trauma"}</h3>
                <button onClick={() => setIsRootCause1Expanded(!isRootCause1Expanded)} className="ml-4 flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-sage-100 transition-all duration-300 shadow-sm hover:shadow-md" aria-label={isRootCause1Expanded ? "Collapse section" : "Expand section"} data-tracking-id="btn-b180ed90ff040924">
                  <svg className={`w-5 h-5 text-sage-600 transition-transform duration-300 ${isRootCause1Expanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
              
              <p className="text-lg text-gray-600 leading-relaxed mb-6">{"People-pleasing often develops as a survival response to trauma, whether it's a single overwhelming event or ongoing experiences that shaped how your nervous system responds to the world."}</p>

              {isRootCause1Expanded && <div className="space-y-6">
                  <div>
                    <h4 className="text-xl font-medium text-sage-800 mb-4 mt-8">"Big T" Trauma</h4>
                    <p className="text-lg text-gray-600 leading-relaxed mb-4">
                      Big T trauma refers to clearly identifiable, often life-threatening or overwhelming events that exceed a person's ability to cope in the moment.
                    </p>
                    <p className="text-lg text-gray-600 leading-relaxed mb-2">For example:</p>
                    <ul className="space-y-2 text-gray-600 mb-6 ml-6">
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Physical or sexual assault</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Serious accidents or injuries</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Natural disasters</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Sudden loss of a loved one</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Severe medical emergencies or invasive procedures</span>
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 className="text-xl font-medium text-sage-800 mb-4 mt-8">Complex Trauma</h4>
                    <p className="text-lg text-gray-600 leading-relaxed mb-4">
                      Complex trauma develops over time through chronic or repeated experiences of stress, fear, or emotional neglect, especially in early relationships.
                    </p>
                    <p className="text-lg text-gray-600 leading-relaxed mb-2">Examples include:</p>
                    <ul className="space-y-2 text-gray-600 mb-6 ml-6">
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Growing up with emotional neglect or inconsistent caregiving</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Parentification (having to care for parents or siblings emotionally or practically)</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Living with alcoholism or addiction in the family</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Witnessing or experiencing domestic violence</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Chronic criticism, shame, or emotional invalidation</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Frequent moves, instability, or lack of safety at home</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-warm-400 mr-3 mt-1">•</span>
                        <span>Physical, emotional, or sexual abuse that occurs repeatedly</span>
                      </li>
                    </ul>
                  </div>

                  <p className="text-lg text-gray-600 leading-relaxed mb-6">
                    While "Big T" trauma can be a single event, complex trauma is often relational—it affects a person's sense of safety, trust, and identity over time. <strong className="text-sage-800">Both can deeply shape the nervous system, emotional patterns, and relationships.</strong>
                  </p>

                  <div className="bg-white rounded-2xl p-6 md:p-8 mt-8">
                    <p className="text-lg text-gray-700 leading-relaxed">
                      <strong className="text-sage-800">When your survival depended on keeping others happy, people-pleasing became your protection.</strong> Your body learned that fawning—being helpful, accommodating, and selfless—kept you safer than saying no, setting boundaries, or expressing your true needs. It was adaptive. It was brilliant. And now, it's time to update the program.
                    </p>
                  </div>
                </div>}
            </div>

            {/* Root Cause 2: Social Conditioning */}
            <div className="my-12 bg-gradient-to-br from-warm-50 to-sage-50 rounded-3xl p-8 md:p-12 border border-warm-100">
              <div className="flex justify-between items-start mb-6">
                <h3 className="text-2xl md:text-3xl font-serif font-light text-sage-800 flex-1">Root Cause 2: Social Conditioning</h3>
                <button onClick={() => setIsRootCause2Expanded(!isRootCause2Expanded)} className="ml-4 flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-sage-100 transition-all duration-300 shadow-sm hover:shadow-md" aria-label={isRootCause2Expanded ? "Collapse section" : "Expand section"} data-tracking-id="btn-178b051cc5c7afe7">
                  <svg className={`w-5 h-5 text-sage-600 transition-transform duration-300 ${isRootCause2Expanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
              
              <p className="text-lg text-gray-600 leading-relaxed mb-6">{"Layered on top of trauma is the social conditioning that girls receive from birth. From childhood, girls are socialized to be accommodating, selfless, and agreeable, rewarded for being \"good girls\" who don't make waves, don't ask for too much, and prioritize others' comfort over their own needs."}</p>
              
              {isRootCause2Expanded && <div className="space-y-6">
                  <p className="text-lg text-gray-600 leading-relaxed">
                    Boys are taught to be assertive and take up space; girls are taught to make room and be pleasant. This cultural conditioning teaches that female worth is tied to caregiving and service, that saying no makes you selfish, that your feelings are "too much," and that love is earned through self-sacrifice.
                  </p>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    These messages become wired into your nervous system, creating automatic responses that feel impossible to override—not because you're weak, but because your body learned early that compliance kept you safe, connected, and loved.
                  </p>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    <strong className="text-sage-800">When trauma meets gendered social conditioning, people-pleasing becomes your default mode.</strong> It's not a personal failing—it's a predictable response to systemic and relational forces that taught you your value lies in being easy, accommodating, and selfless. But you don't have to stay stuck in this pattern. Healing happens when you recognize these roots, regulate your nervous system, and reclaim your right to take up space.
                  </p>
                </div>}
            </div>

          </div>
        </div>
      </section>

      {/* Flower Divider */}
      <section className="bg-white">
        <div className="relative w-full h-[400px] overflow-hidden">
          <img alt="Beautiful flower" className="w-full h-full object-cover object-top" src="https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/user_33tbl7B6e1bXN6KW4wjrevvqrth/cmhd1gtfc0001vb0yeeofdn9z/images/theone-yh8ufxwj8i9.jpg" />
          <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
            <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
            <span className="hidden drop-shadow-md group-hover/attribution:block">
              Image on{' '}
              <a href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
              color: '#fff',
              textDecoration: 'none'
            }} data-tracking-id="link-39c3baaa51d8ca0a">
                Unsplash
              </a>{' '}
              by{' '}
              <a href="https://unsplash.com/@onelushlife?utm_source=makerdevi&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
              color: '#fff',
              textDecoration: 'none'
            }} data-tracking-id="link-a2e23ff01df9d607">
                Kaishin | OneLushLife
              </a>
            </span>
          </span>
        </div>
      </section>

      {/* When I Work With You Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-16 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            {/* WHEN I WORK WITH YOU SECTION */}
            <h2 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mb-6">{"Somatic & IFS Therapy for People-Pleasing"}</h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">In our work together, we'll gently address what's been living underneath your pleasing patterns. You'll leave each session, starting with the first, with practical tools that you can use in your daily life and the beginnings of a kinder, more compassionate connection with yourself.</p>

            <div className="space-y-6 mb-12">
              <div className="bg-cream-50 p-6 rounded-xl border border-cream-200">
                <h3 className="text-xl font-medium text-sage-800 mb-3">Regulating Your Nervous System</h3>
                <p className="text-gray-600 leading-relaxed">We'll use somatic (body-based) practices to help you move out of chronic fight, flight, freeze or fawn responses. You'll learn to recognize your body's signals, regulate your nervous system, and build a felt sense of safety inside - so you can respond to stress with choice rather than automatic people-pleasing.</p>
              </div>

              <div className="bg-cream-50 p-6 rounded-xl border border-cream-200">
                <h3 className="text-xl font-medium text-sage-800 mb-3">{"Understanding Your People-Pleasing Parts with IFS"}</h3>
                <p className="text-gray-600 leading-relaxed">{"We'll explore how and why people-pleasing became your survival strategy. What did it protect you from? What generational patterns were you unconsciously repeating? Understanding the \"why\" helps you move forward with compassion, not shame. "}</p>
              </div>

              <div className="bg-cream-50 p-6 rounded-xl border border-cream-200">
                <h3 className="text-xl font-medium text-sage-800 mb-3">Setting Boundaries (Even When Guilt Shows Up)</h3>
                <p className="text-gray-600 leading-relaxed">We'll practice setting boundaries in ways that feel true and safe to you, even when guilt, anxiety, or fear of disappointing others arise.</p>
              </div>

              <div className="bg-cream-50 p-6 rounded-xl border border-cream-200">
                <h3 className="text-xl font-medium text-sage-800 mb-3">{"Healing Relational Patterns & Breaking Generational Cycles"}</h3>
                <p className="text-gray-600 leading-relaxed">{"We'll work on the relational patterns that keep you abandoning yourself, while building self-trust, healthier boundaries, and new ways of showing up in your relationships. As you change these patterns, you create space for the next generation to learn that connection doesn't require abandoning themselves."}</p>
              </div>



              <div className="bg-cream-50 p-6 rounded-xl border border-cream-200">
                <h3 className="text-xl font-medium text-sage-800 mb-3">Reclaiming Your Authentic Self</h3>
                <p className="text-gray-600 leading-relaxed">{"Beyond just saying no, you'll rediscover who you are when you're not performing for others. What do you actually want? What brings you joy? What matters to you? We'll create space for you to explore and honor your authentic self fully."}</p>
              </div>
            </div>

            {/* HOW I WORK WITH YOU SECTION */}
            <h2 className="text-3xl md:text-4xl font-serif font-light text-sage-800 mt-20 mb-6"></h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6"></p>
            <ul className="space-y-3 text-gray-600 mt-0 mb-0 ml-0 mr-0 pt-0 pb-0 pl-0 pr-0">
              <li className="flex items-start">
                <span className="text-sage-300 mr-3 font-medium"></span>
                <span></span>
              </li>
              <li className="flex items-start"></li>
              <li className="flex items-start"></li>
              <li className="flex items-start"></li>
              <li className="flex items-start"></li>
              <li className="flex items-start"></li>
            </ul>

            <p className="text-lg text-gray-600 leading-relaxed mb-8"></p>

          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="px-4 sm:px-6 lg:px-8 py-20 bg-gradient-to-br from-sage-50 to-warm-50">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-light text-sage-800 mb-6">
            Ready to Break the Cycle?
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">{"Book a free 20-minute consultation to see if we're a good fit. No pressure, no obligation, just a conversation about how I can support you in healing yourself and your lineage."}</p>
          <Link to="/#booking" className="inline-block bg-warm-500 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-warm-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105" data-tracking-id="link-54fd0c37e864718d"><a href="https://calendly.com/yphilipos/30min" className="contents" data-tracking-id="link-45ed3677929a9bba"><a href="https://calendly.com/yphilipos/30min" className="contents" data-tracking-id="link-1f500bfccc531c46"><span>
            Schedule Your Free Consultation
          </span></a></a></Link>
        </div>
      </section>

      {/* PDF Lead Magnet Modal */}
      <PDFLeadMagnet isOpen={isPDFModalOpen} onClose={() => setIsPDFModalOpen(false)} />
    </div>;
}
export default IndividualSessions;